'use client';
import { usePathname, useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

type SelectorButtonProps = {
  options: string[];
  onSelect: (selected: string) => void;
  icon?: React.ReactNode;
  showBackground?: boolean;
  // icons?: { [key: string]: React.ReactNode }
};

const SelectorButton: React.FC<SelectorButtonProps> = ({
  options,
  onSelect,
  showBackground = true,
  // icons = {}
}) => {
  // const [selectedOption, setSelectedOption] = useState<string>(options[0])
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();
  const pathname = usePathname();

  const langOptions = ['en', 'de', 'it', 'es', 'ar'];

  const currentLang = langOptions.includes(pathname.split('/')[1]?.toLowerCase())
    ? pathname.split('/')[1].toLowerCase()
    : 'en';

  const handleSelect = (lang: string) => {
    const newPath = `/${lang.toLowerCase()}${pathname.substring(3)}`;
    router.push(newPath);
    onSelect(lang);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(prev => !prev)}
        className={`flex items-center gap-2 rounded px-4 py-2 text-base font-medium ${
          showBackground ? 'bg-clr-92 text-white' : 'bg-transparent text-clr-0a dark:text-white'
        }`}
      >
        {currentLang.toUpperCase()}
        {isOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
      </button>

      {isOpen && (
        <div className="absolute z-50 mt-2 rounded border bg-white shadow-lg dark:bg-slate-950 dark:text-white">
          {options
            .filter(option => option.toLowerCase() !== currentLang)
            .map(option => (
              <button
                key={option}
                onClick={() => handleSelect(option)}
                className="block w-full px-4 py-2 text-left text-base font-medium text-black dark:text-white"
              >
                {option.toUpperCase()}
              </button>
            ))}
        </div>
      )}
    </div>
  );
};

export default SelectorButton;
